/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
// import {
//     AsyncResult,
//     callActionOrExecute,
//     DataServiceQuery,
//     IContext,
//     IDataServiceRequest,
//     IQueryResultSettings
//     // IQueryResultSettings,
//     // NullResult
// } from '@msdyn365-commerce/retail-proxy';
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
    // IQueryResultSettings,
    // NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function sWGCustomerDataQuery(iD?: number): DataServiceQuery {
    const key = iD ? { ID: iD } : null;
    return new DataServiceQuery('SWGCustomerData', 'SWGCustomerDataView', DataServiceEntities.SWGCustomerDataViewExtensionClass, key);
}

export function createSWGGetCustomerDataInput(customerId: string): IDataServiceRequest {
    const query = sWGCustomerDataQuery();
    return query.createDataServiceRequestForOperation(
        'SWGGetCustomerData',
        true,
        DataServiceEntities.SWGCustomerDataViewExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISWGCustomerDataView' },
        { customerId: customerId }
    );
}

export function sWGGetCustomerDataAsync(context: IContext, customerId: string): AsyncResult<DataServiceEntities.ISWGCustomerDataView> {
    const request = createSWGGetCustomerDataInput(customerId);
    return callActionOrExecute<DataServiceEntities.ISWGCustomerDataView>(request, context.callerContext);
}

export function createSWGGetCustomerEditableDataInput(customerId: string): IDataServiceRequest {
    const query = sWGCustomerDataQuery();
    return query.createDataServiceRequestForOperation(
        'SWGGetCustomerEditableData',
        true,
        DataServiceEntities.SWGCustomerDataEditableExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISWGCustomerDataEditable' },
        { customerId: customerId }
    );
}

export function sWGGetCustomerEditableDataAsync(
    context: IContext,
    customerId: string
): AsyncResult<DataServiceEntities.ISWGCustomerDataEditable> {
    const request = createSWGGetCustomerEditableDataInput(customerId);
    return callActionOrExecute<DataServiceEntities.ISWGCustomerDataEditable>(request, context.callerContext);
}

export function createSWGUpdateCustomerDataInput(
    accountNumber: string,
    partyRecID: string,
    name: string,
    personalTitle: string,
    professionalTitle: string,
    birthDay: string,
    birthMonth: string,
    birthYear: string,
    primaryFaxRecId: string,
    primaryFax: string,
    orgPrimaryFaxRecId: string,
    orgPrimaryFax: string,
    orgPrimaryPhoneRecId: string,
    orgPrimaryPhone: string,
    orgPrimaryUrlRecId: string,
    orgPrimaryUrl: string,
    addressRecId: string,
    addressName: string,
    addressStreet: string,
    addressCity: string,
    addressZip: string,
    addressCountryCode: string,
    deliveryPhoneRecId: string,
    deliveryPhoneNumber: string,
    primaryContactPhone: string,
    primaryContactPhoneRecId: string
): IDataServiceRequest {
    const query = sWGCustomerDataQuery();
    return query.createDataServiceRequestForOperation(
        'SWGUpdateCustomerData',
        true,
        DataServiceEntities.SWGUpdateCustomerDataEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISWGUpdateCustomerDataEntity' },
        {
            accountNumber: accountNumber,
            partyRecID: partyRecID,
            name: name,
            personalTitle: personalTitle,
            professionalTitle: professionalTitle,
            birthDay: birthDay,
            birthMonth: birthMonth,
            birthYear: birthYear,
            primaryFaxRecId: primaryFaxRecId,
            primaryFax: primaryFax,
            orgPrimaryFaxRecId: orgPrimaryFaxRecId,
            orgPrimaryFax: orgPrimaryFax,
            orgPrimaryPhoneRecId: orgPrimaryPhoneRecId,
            orgPrimaryPhone: orgPrimaryPhone,
            orgPrimaryUrlRecId: orgPrimaryUrlRecId,
            orgPrimaryUrl: orgPrimaryUrl,
            addressRecId: addressRecId,
            addressName: addressName,
            addressStreet: addressStreet,
            addressCity: addressCity,
            addressZip: addressZip,
            addressCountryCode: addressCountryCode,
            deliveryPhoneRecId: deliveryPhoneRecId,
            deliveryPhoneNumber: deliveryPhoneNumber,
            primaryContactPhone: primaryContactPhone,
            primaryContactPhoneRecId: primaryContactPhoneRecId
        }
    );
}

export function sWGUpdateCustomerDataAsync(
    context: IContext,
    accountNumber: string,
    partyRecID: string,
    name: string,
    personalTitle: string,
    professionalTitle: string,
    birthDay: string,
    birthMonth: string,
    birthYear: string,
    primaryFaxRecId: string,
    primaryFax: string,
    orgPrimaryFaxRecId: string,
    orgPrimaryFax: string,
    orgPrimaryPhoneRecId: string,
    orgPrimaryPhone: string,
    orgPrimaryUrlRecId: string,
    orgPrimaryUrl: string,
    addressRecId: string,
    addressName: string,
    addressStreet: string,
    addressCity: string,
    addressZip: string,
    addressCountryCode: string,
    deliveryPhoneRecId: string,
    deliveryPhoneNumber: string,
    primaryContactPhone: string,
    primaryContactPhoneRecId: string
): AsyncResult<DataServiceEntities.ISWGUpdateCustomerDataEntity> {
    const request = createSWGUpdateCustomerDataInput(
        accountNumber,
        partyRecID,
        name,
        personalTitle,
        professionalTitle,
        birthDay,
        birthMonth,
        birthYear,
        primaryFaxRecId,
        primaryFax,
        orgPrimaryFaxRecId,
        orgPrimaryFax,
        orgPrimaryPhoneRecId,
        orgPrimaryPhone,
        orgPrimaryUrlRecId,
        orgPrimaryUrl,
        addressRecId,
        addressName,
        addressStreet,
        addressCity,
        addressZip,
        addressCountryCode,
        deliveryPhoneRecId,
        deliveryPhoneNumber,
        primaryContactPhone,
        primaryContactPhoneRecId
    );
    return callActionOrExecute<DataServiceEntities.ISWGUpdateCustomerDataEntity>(request, context.callerContext);
}

// @ts-ignore
function sWGInventoryDataQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('SWGInventoryData', 'SWGInventoryData', DataServiceEntities.SWGInventoryDataExtensionClass, key);
}

export function createSWGGetInventoryDataInput(
    queryResultSettings: IQueryResultSettings,
    productId: number,
    requestedQuantity: number
): IDataServiceRequest {
    const query = sWGInventoryDataQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SWGGetInventoryData',
        true,
        DataServiceEntities.SWGInventoryDataExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISWGInventoryData' },
        { productId: productId, requestedQuantity: requestedQuantity }
    );
}

export function sWGGetInventoryDataAsync(
    context: IContext,
    productId: number,
    requestedQuantity: number
): AsyncResult<DataServiceEntities.ISWGInventoryData[]> {
    const request = createSWGGetInventoryDataInput(context.queryResultSettings || {}, productId, requestedQuantity);
    return callActionOrExecute<DataServiceEntities.ISWGInventoryData[]>(request, context.callerContext);
}
